const state = {
  articleList: [],
  total: 0,
  currentPage: 1,
  currentArticle: null
}

const mutations = {
  SET_ARTICLES(state, { list, total, page }) {
    state.articleList = list || []
    state.total = total || 0
    state.currentPage = page || 1
  },
  SET_ARTICLE_DETAIL(state, article) {
    state.currentArticle = article
  },
  CLEAR_ARTICLE(state) {
    state.currentArticle = null
  }
}

const actions = {
  fetchArticles({ commit }, params) {
    return new Promise((resolve, reject) => {
      import('@/api/article').then(({ getArticleList }) => {
        getArticleList(params)
          .then(data => {
            commit('SET_ARTICLES', {
              list: data.records || data.list || [],
              total: data.total || 0,
              page: data.current || data.page || params.page || 1
            })
            resolve(data)
          })
          .catch(error => reject(error))
      })
    })
  },

  fetchArticleDetail({ commit }, id) {
    return new Promise((resolve, reject) => {
      import('@/api/article').then(({ getArticleDetail }) => {
        getArticleDetail(id)
          .then(data => {
            commit('SET_ARTICLE_DETAIL', data)
            resolve(data)
          })
          .catch(error => reject(error))
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
